import React from "react";
import PropTypes from "prop-types";

const LandingLogo = ({ className = "" }) => (
  <div className={`logo ${className}`.trim()}>
    <div className="logo-icon">O</div>
    <span>
      Odoo<span className="accent">-API</span>
    </span>
  </div>
);

LandingLogo.propTypes = {
  className: PropTypes.string
};

export default LandingLogo;
